var map = {
	"./categories/1508": 229,
	"./categories/1508.png": 229,
	"./categories/35": 230,
	"./categories/35.png": 230,
	"./categories/63": 231,
	"./categories/63.png": 231,
	"./categories/64": 232,
	"./categories/64.png": 232,
	"./categories/81": 233,
	"./categories/81.png": 233,
	"./categories/88": 234,
	"./categories/88.png": 234,
	"./categories/89": 235,
	"./categories/89.png": 235,
	"./categories/90": 236,
	"./categories/90.png": 236,
	"./categories/91": 237,
	"./categories/91.png": 237,
	"./categories/armor-customization": 238,
	"./categories/armor-customization.png": 238,
	"./categories/dsp-icon": 239,
	"./categories/dsp-icon.png": 239,
	"./categories/dyson-sphere-96": 240,
	"./categories/dyson-sphere-96.png": 240,
	"./categories/dyson_sphere": 241,
	"./categories/dyson_sphere.png": 241,
	"./categories/factory": 242,
	"./categories/factory.png": 242,
	"./categories/mecha": 243,
	"./categories/mecha.png": 243,
	"./categories/power": 244,
	"./categories/power.png": 244,
	"./categories/structure-point-icon": 245,
	"./categories/structure-point-icon.png": 245,
	"./entities/100": 246,
	"./entities/100.png": 246,
	"./entities/1000": 247,
	"./entities/1000.png": 247,
	"./entities/1001": 248,
	"./entities/1001.png": 248,
	"./entities/1002": 249,
	"./entities/1002.png": 249,
	"./entities/1003": 250,
	"./entities/1003.png": 250,
	"./entities/1004": 251,
	"./entities/1004.png": 251,
	"./entities/1005": 252,
	"./entities/1005.png": 252,
	"./entities/1006": 253,
	"./entities/1006.png": 253,
	"./entities/1007": 254,
	"./entities/1007.png": 254,
	"./entities/1011": 255,
	"./entities/1011.png": 255,
	"./entities/1012": 256,
	"./entities/1012.png": 256,
	"./entities/1013": 257,
	"./entities/1013.png": 257,
	"./entities/1014": 258,
	"./entities/1014.png": 258,
	"./entities/1015": 259,
	"./entities/1015.png": 259,
	"./entities/1016": 260,
	"./entities/1016.png": 260,
	"./entities/1030": 261,
	"./entities/1030.png": 261,
	"./entities/1031": 262,
	"./entities/1031.png": 262,
	"./entities/1101": 263,
	"./entities/1101.png": 263,
	"./entities/1102": 264,
	"./entities/1102.png": 264,
	"./entities/1103": 265,
	"./entities/1103.png": 265,
	"./entities/1104": 266,
	"./entities/1104.png": 266,
	"./entities/1105": 267,
	"./entities/1105.png": 267,
	"./entities/1106": 268,
	"./entities/1106.png": 268,
	"./entities/1107": 269,
	"./entities/1107.png": 269,
	"./entities/1108": 270,
	"./entities/1108.png": 270,
	"./entities/1109": 271,
	"./entities/1109.png": 271,
	"./entities/1110": 272,
	"./entities/1110.png": 272,
	"./entities/1111": 273,
	"./entities/1111.png": 273,
	"./entities/1112": 274,
	"./entities/1112.png": 274,
	"./entities/1113": 275,
	"./entities/1113.png": 275,
	"./entities/1114": 276,
	"./entities/1114.png": 276,
	"./entities/1115": 277,
	"./entities/1115.png": 277,
	"./entities/1116": 278,
	"./entities/1116.png": 278,
	"./entities/1117": 279,
	"./entities/1117.png": 279,
	"./entities/1118": 280,
	"./entities/1118.png": 280,
	"./entities/1119": 281,
	"./entities/1119.png": 281,
	"./entities/1120": 282,
	"./entities/1120.png": 282,
	"./entities/1121": 283,
	"./entities/1121.png": 283,
	"./entities/1122": 284,
	"./entities/1122.png": 284,
	"./entities/1123": 285,
	"./entities/1123.png": 285,
	"./entities/1124": 286,
	"./entities/1124.png": 286,
	"./entities/1125": 287,
	"./entities/1125.png": 287,
	"./entities/1126": 288,
	"./entities/1126.png": 288,
	"./entities/1127": 289,
	"./entities/1127.png": 289,
	"./entities/1128": 290,
	"./entities/1128.png": 290,
	"./entities/1129": 291,
	"./entities/1129.png": 291,
	"./entities/1130": 292,
	"./entities/1130.png": 292,
	"./entities/1131": 293,
	"./entities/1131.png": 293,
	"./entities/1141": 294,
	"./entities/1141.png": 294,
	"./entities/1142": 295,
	"./entities/1142.png": 295,
	"./entities/1143": 296,
	"./entities/1143.png": 296,
	"./entities/1201": 297,
	"./entities/1201.png": 297,
	"./entities/1202": 298,
	"./entities/1202.png": 298,
	"./entities/1203": 299,
	"./entities/1203.png": 299,
	"./entities/1204": 300,
	"./entities/1204.png": 300,
	"./entities/1205": 301,
	"./entities/1205.png": 301,
	"./entities/1206": 302,
	"./entities/1206.png": 302,
	"./entities/1208": 303,
	"./entities/1208.png": 303,
	"./entities/1209": 304,
	"./entities/1209.png": 304,
	"./entities/1210": 305,
	"./entities/1210.png": 305,
	"./entities/1301": 306,
	"./entities/1301.png": 306,
	"./entities/1302": 307,
	"./entities/1302.png": 307,
	"./entities/1303": 308,
	"./entities/1303.png": 308,
	"./entities/1304": 309,
	"./entities/1304.png": 309,
	"./entities/1305": 310,
	"./entities/1305.png": 310,
	"./entities/1401": 311,
	"./entities/1401.png": 311,
	"./entities/1402": 312,
	"./entities/1402.png": 312,
	"./entities/1403": 313,
	"./entities/1403.png": 313,
	"./entities/1404": 314,
	"./entities/1404.png": 314,
	"./entities/1405": 315,
	"./entities/1405.png": 315,
	"./entities/1406": 316,
	"./entities/1406.png": 316,
	"./entities/1407": 317,
	"./entities/1407.png": 317,
	"./entities/1501": 318,
	"./entities/1501.png": 318,
	"./entities/1502": 319,
	"./entities/1502.png": 319,
	"./entities/1503": 320,
	"./entities/1503.png": 320,
	"./entities/16": 321,
	"./entities/16.png": 321,
	"./entities/1601": 322,
	"./entities/1601.png": 322,
	"./entities/1602": 323,
	"./entities/1602.png": 323,
	"./entities/1603": 324,
	"./entities/1603.png": 324,
	"./entities/1604": 325,
	"./entities/1604.png": 325,
	"./entities/1605": 326,
	"./entities/1605.png": 326,
	"./entities/1606": 327,
	"./entities/1606.png": 327,
	"./entities/1607": 328,
	"./entities/1607.png": 328,
	"./entities/1608": 329,
	"./entities/1608.png": 329,
	"./entities/1609": 330,
	"./entities/1609.png": 330,
	"./entities/1610": 331,
	"./entities/1610.png": 331,
	"./entities/1611": 332,
	"./entities/1611.png": 332,
	"./entities/1612": 333,
	"./entities/1612.png": 333,
	"./entities/1613": 334,
	"./entities/1613.png": 334,
	"./entities/1801": 335,
	"./entities/1801.png": 335,
	"./entities/1802": 336,
	"./entities/1802.png": 336,
	"./entities/1803": 337,
	"./entities/1803.png": 337,
	"./entities/1804": 338,
	"./entities/1804.png": 338,
	"./entities/2001": 339,
	"./entities/2001.png": 339,
	"./entities/2002": 340,
	"./entities/2002.png": 340,
	"./entities/2003": 341,
	"./entities/2003.png": 341,
	"./entities/2011": 342,
	"./entities/2011.png": 342,
	"./entities/2012": 343,
	"./entities/2012.png": 343,
	"./entities/2013": 344,
	"./entities/2013.png": 344,
	"./entities/2014": 345,
	"./entities/2014.png": 345,
	"./entities/2020": 346,
	"./entities/2020.png": 346,
	"./entities/2030": 347,
	"./entities/2030.png": 347,
	"./entities/2040": 348,
	"./entities/2040.png": 348,
	"./entities/2101": 349,
	"./entities/2101.png": 349,
	"./entities/2102": 350,
	"./entities/2102.png": 350,
	"./entities/2103": 351,
	"./entities/2103.png": 351,
	"./entities/2104": 352,
	"./entities/2104.png": 352,
	"./entities/2105": 353,
	"./entities/2105.png": 353,
	"./entities/2106": 354,
	"./entities/2106.png": 354,
	"./entities/2107": 355,
	"./entities/2107.png": 355,
	"./entities/2201": 356,
	"./entities/2201.png": 356,
	"./entities/2202": 357,
	"./entities/2202.png": 357,
	"./entities/2203": 358,
	"./entities/2203.png": 358,
	"./entities/2204": 359,
	"./entities/2204.png": 359,
	"./entities/2205": 360,
	"./entities/2205.png": 360,
	"./entities/2206": 361,
	"./entities/2206.png": 361,
	"./entities/2207": 362,
	"./entities/2207.png": 362,
	"./entities/2208": 363,
	"./entities/2208.png": 363,
	"./entities/2209": 364,
	"./entities/2209.png": 364,
	"./entities/2210": 365,
	"./entities/2210.png": 365,
	"./entities/2211": 366,
	"./entities/2211.png": 366,
	"./entities/2212": 367,
	"./entities/2212.png": 367,
	"./entities/2213": 368,
	"./entities/2213.png": 368,
	"./entities/2301": 369,
	"./entities/2301.png": 369,
	"./entities/2302": 370,
	"./entities/2302.png": 370,
	"./entities/2303": 371,
	"./entities/2303.png": 371,
	"./entities/2304": 372,
	"./entities/2304.png": 372,
	"./entities/2305": 373,
	"./entities/2305.png": 373,
	"./entities/2306": 374,
	"./entities/2306.png": 374,
	"./entities/2307": 375,
	"./entities/2307.png": 375,
	"./entities/2308": 376,
	"./entities/2308.png": 376,
	"./entities/2309": 377,
	"./entities/2309.png": 377,
	"./entities/2310": 378,
	"./entities/2310.png": 378,
	"./entities/2311": 379,
	"./entities/2311.png": 379,
	"./entities/2312": 380,
	"./entities/2312.png": 380,
	"./entities/2313": 381,
	"./entities/2313.png": 381,
	"./entities/2313_old": 382,
	"./entities/2313_old.png": 382,
	"./entities/2314": 383,
	"./entities/2314.png": 383,
	"./entities/2315": 384,
	"./entities/2315.png": 384,
	"./entities/2316": 385,
	"./entities/2316.png": 385,
	"./entities/2317": 386,
	"./entities/2317.png": 386,
	"./entities/2318": 387,
	"./entities/2318.png": 387,
	"./entities/2319": 388,
	"./entities/2319.png": 388,
	"./entities/25": 389,
	"./entities/25.png": 389,
	"./entities/29": 390,
	"./entities/29.png": 390,
	"./entities/2901": 391,
	"./entities/2901.png": 391,
	"./entities/2902": 392,
	"./entities/2902.png": 392,
	"./entities/3001": 393,
	"./entities/3001.png": 393,
	"./entities/3002": 394,
	"./entities/3002.png": 394,
	"./entities/3003": 395,
	"./entities/3003.png": 395,
	"./entities/3004": 396,
	"./entities/3004.png": 396,
	"./entities/3005": 397,
	"./entities/3005.png": 397,
	"./entities/3006": 398,
	"./entities/3006.png": 398,
	"./entities/3007": 399,
	"./entities/3007.png": 399,
	"./entities/3008": 400,
	"./entities/3008.png": 400,
	"./entities/3009": 401,
	"./entities/3009.png": 401,
	"./entities/3010": 402,
	"./entities/3010.png": 402,
	"./entities/32": 403,
	"./entities/32.png": 403,
	"./entities/35": 404,
	"./entities/35.png": 404,
	"./entities/37": 405,
	"./entities/37.png": 405,
	"./entities/40": 406,
	"./entities/40.png": 406,
	"./entities/5001": 407,
	"./entities/5001.png": 407,
	"./entities/5002": 408,
	"./entities/5002.png": 408,
	"./entities/5003": 409,
	"./entities/5003.png": 409,
	"./entities/5101": 410,
	"./entities/5101.png": 410,
	"./entities/5102": 411,
	"./entities/5102.png": 411,
	"./entities/5103": 412,
	"./entities/5103.png": 412,
	"./entities/5111": 413,
	"./entities/5111.png": 413,
	"./entities/5112": 414,
	"./entities/5112.png": 414,
	"./entities/5201": 415,
	"./entities/5201.png": 415,
	"./entities/5202": 416,
	"./entities/5202.png": 416,
	"./entities/5203": 417,
	"./entities/5203.png": 417,
	"./entities/5204": 418,
	"./entities/5204.png": 418,
	"./entities/5205": 419,
	"./entities/5205.png": 419,
	"./entities/5206": 420,
	"./entities/5206.png": 420,
	"./entities/58": 421,
	"./entities/58.png": 421,
	"./entities/6001": 422,
	"./entities/6001.png": 422,
	"./entities/6002": 423,
	"./entities/6002.png": 423,
	"./entities/6003": 424,
	"./entities/6003.png": 424,
	"./entities/6004": 425,
	"./entities/6004.png": 425,
	"./entities/6005": 426,
	"./entities/6005.png": 426,
	"./entities/6006": 427,
	"./entities/6006.png": 427,
	"./entities/61": 428,
	"./entities/61.png": 428,
	"./entities/69": 429,
	"./entities/69.png": 429,
	"./entities/79": 430,
	"./entities/79.png": 430,
	"./entities/default": 431,
	"./entities/default.png": 431,
	"./recipes/1": 432,
	"./recipes/1.png": 432,
	"./recipes/10": 433,
	"./recipes/10.png": 433,
	"./recipes/100": 434,
	"./recipes/100.png": 434,
	"./recipes/101": 435,
	"./recipes/101.png": 435,
	"./recipes/102": 436,
	"./recipes/102.png": 436,
	"./recipes/103": 437,
	"./recipes/103.png": 437,
	"./recipes/104": 438,
	"./recipes/104.png": 438,
	"./recipes/105": 439,
	"./recipes/105.png": 439,
	"./recipes/106": 440,
	"./recipes/106.png": 440,
	"./recipes/107": 441,
	"./recipes/107.png": 441,
	"./recipes/108": 442,
	"./recipes/108.png": 442,
	"./recipes/109": 443,
	"./recipes/109.png": 443,
	"./recipes/109_old": 444,
	"./recipes/109_old.png": 444,
	"./recipes/11": 445,
	"./recipes/11.png": 445,
	"./recipes/110": 446,
	"./recipes/110.png": 446,
	"./recipes/111": 447,
	"./recipes/111.png": 447,
	"./recipes/112": 448,
	"./recipes/112.png": 448,
	"./recipes/113": 449,
	"./recipes/113.png": 449,
	"./recipes/114": 450,
	"./recipes/114.png": 450,
	"./recipes/115": 451,
	"./recipes/115.png": 451,
	"./recipes/116": 452,
	"./recipes/116.png": 452,
	"./recipes/117": 453,
	"./recipes/117.png": 453,
	"./recipes/118": 454,
	"./recipes/118.png": 454,
	"./recipes/119": 455,
	"./recipes/119.png": 455,
	"./recipes/12": 456,
	"./recipes/12.png": 456,
	"./recipes/120": 457,
	"./recipes/120.png": 457,
	"./recipes/121": 458,
	"./recipes/121.png": 458,
	"./recipes/122": 459,
	"./recipes/122.png": 459,
	"./recipes/123": 460,
	"./recipes/123.png": 460,
	"./recipes/124": 461,
	"./recipes/124.png": 461,
	"./recipes/125": 462,
	"./recipes/125.png": 462,
	"./recipes/126": 463,
	"./recipes/126.png": 463,
	"./recipes/127": 464,
	"./recipes/127.png": 464,
	"./recipes/128": 465,
	"./recipes/128.png": 465,
	"./recipes/129": 466,
	"./recipes/129.png": 466,
	"./recipes/13": 467,
	"./recipes/13.png": 467,
	"./recipes/130": 468,
	"./recipes/130.png": 468,
	"./recipes/131": 469,
	"./recipes/131.png": 469,
	"./recipes/132": 470,
	"./recipes/132.png": 470,
	"./recipes/133": 471,
	"./recipes/133.png": 471,
	"./recipes/134": 472,
	"./recipes/134.png": 472,
	"./recipes/135": 473,
	"./recipes/135.png": 473,
	"./recipes/136": 474,
	"./recipes/136.png": 474,
	"./recipes/137": 475,
	"./recipes/137.png": 475,
	"./recipes/138": 476,
	"./recipes/138.png": 476,
	"./recipes/139": 477,
	"./recipes/139.png": 477,
	"./recipes/14": 478,
	"./recipes/14.png": 478,
	"./recipes/140": 479,
	"./recipes/140.png": 479,
	"./recipes/141": 480,
	"./recipes/141.png": 480,
	"./recipes/142": 481,
	"./recipes/142.png": 481,
	"./recipes/143": 482,
	"./recipes/143.png": 482,
	"./recipes/144": 483,
	"./recipes/144.png": 483,
	"./recipes/145": 484,
	"./recipes/145.png": 484,
	"./recipes/146": 485,
	"./recipes/146.png": 485,
	"./recipes/147": 486,
	"./recipes/147.png": 486,
	"./recipes/148": 487,
	"./recipes/148.png": 487,
	"./recipes/149": 488,
	"./recipes/149.png": 488,
	"./recipes/15": 489,
	"./recipes/15.png": 489,
	"./recipes/150": 490,
	"./recipes/150.png": 490,
	"./recipes/151": 491,
	"./recipes/151.png": 491,
	"./recipes/152": 492,
	"./recipes/152.png": 492,
	"./recipes/153": 493,
	"./recipes/153.png": 493,
	"./recipes/154": 494,
	"./recipes/154.png": 494,
	"./recipes/155": 495,
	"./recipes/155.png": 495,
	"./recipes/156": 496,
	"./recipes/156.png": 496,
	"./recipes/157": 497,
	"./recipes/157.png": 497,
	"./recipes/158": 498,
	"./recipes/158.png": 498,
	"./recipes/159": 499,
	"./recipes/159.png": 499,
	"./recipes/16": 500,
	"./recipes/16.png": 500,
	"./recipes/160": 501,
	"./recipes/160.png": 501,
	"./recipes/17": 502,
	"./recipes/17.png": 502,
	"./recipes/18": 503,
	"./recipes/18.png": 503,
	"./recipes/19": 504,
	"./recipes/19.png": 504,
	"./recipes/2": 505,
	"./recipes/2.png": 505,
	"./recipes/20": 506,
	"./recipes/20.png": 506,
	"./recipes/21": 507,
	"./recipes/21.png": 507,
	"./recipes/22": 508,
	"./recipes/22.png": 508,
	"./recipes/23": 509,
	"./recipes/23.png": 509,
	"./recipes/24": 510,
	"./recipes/24.png": 510,
	"./recipes/25": 511,
	"./recipes/25.png": 511,
	"./recipes/26": 512,
	"./recipes/26.png": 512,
	"./recipes/27": 513,
	"./recipes/27.png": 513,
	"./recipes/28": 514,
	"./recipes/28.png": 514,
	"./recipes/29": 515,
	"./recipes/29.png": 515,
	"./recipes/3": 516,
	"./recipes/3.png": 516,
	"./recipes/30": 517,
	"./recipes/30.png": 517,
	"./recipes/31": 518,
	"./recipes/31.png": 518,
	"./recipes/32": 519,
	"./recipes/32.png": 519,
	"./recipes/33": 520,
	"./recipes/33.png": 520,
	"./recipes/34": 521,
	"./recipes/34.png": 521,
	"./recipes/35": 522,
	"./recipes/35.png": 522,
	"./recipes/36": 523,
	"./recipes/36.png": 523,
	"./recipes/37": 524,
	"./recipes/37.png": 524,
	"./recipes/38": 525,
	"./recipes/38.png": 525,
	"./recipes/39": 526,
	"./recipes/39.png": 526,
	"./recipes/4": 527,
	"./recipes/4.png": 527,
	"./recipes/40": 528,
	"./recipes/40.png": 528,
	"./recipes/41": 529,
	"./recipes/41.png": 529,
	"./recipes/42": 530,
	"./recipes/42.png": 530,
	"./recipes/43": 531,
	"./recipes/43.png": 531,
	"./recipes/44": 532,
	"./recipes/44.png": 532,
	"./recipes/45": 533,
	"./recipes/45.png": 533,
	"./recipes/46": 534,
	"./recipes/46.png": 534,
	"./recipes/47": 535,
	"./recipes/47.png": 535,
	"./recipes/48": 536,
	"./recipes/48.png": 536,
	"./recipes/49": 537,
	"./recipes/49.png": 537,
	"./recipes/5": 538,
	"./recipes/5.png": 538,
	"./recipes/50": 539,
	"./recipes/50.png": 539,
	"./recipes/51": 540,
	"./recipes/51.png": 540,
	"./recipes/52": 541,
	"./recipes/52.png": 541,
	"./recipes/53": 542,
	"./recipes/53.png": 542,
	"./recipes/54": 543,
	"./recipes/54.png": 543,
	"./recipes/55": 544,
	"./recipes/55.png": 544,
	"./recipes/56": 545,
	"./recipes/56.png": 545,
	"./recipes/57": 546,
	"./recipes/57.png": 546,
	"./recipes/58": 547,
	"./recipes/58.png": 547,
	"./recipes/59": 548,
	"./recipes/59.png": 548,
	"./recipes/6": 549,
	"./recipes/6.png": 549,
	"./recipes/60": 550,
	"./recipes/60.png": 550,
	"./recipes/61": 551,
	"./recipes/61.png": 551,
	"./recipes/62": 552,
	"./recipes/62.png": 552,
	"./recipes/63": 553,
	"./recipes/63.png": 553,
	"./recipes/64": 554,
	"./recipes/64.png": 554,
	"./recipes/65": 555,
	"./recipes/65.png": 555,
	"./recipes/66": 556,
	"./recipes/66.png": 556,
	"./recipes/67": 557,
	"./recipes/67.png": 557,
	"./recipes/68": 558,
	"./recipes/68.png": 558,
	"./recipes/69": 559,
	"./recipes/69.png": 559,
	"./recipes/7": 560,
	"./recipes/7.png": 560,
	"./recipes/70": 561,
	"./recipes/70.png": 561,
	"./recipes/71": 562,
	"./recipes/71.png": 562,
	"./recipes/72": 563,
	"./recipes/72.png": 563,
	"./recipes/73": 564,
	"./recipes/73.png": 564,
	"./recipes/74": 565,
	"./recipes/74.png": 565,
	"./recipes/75": 566,
	"./recipes/75.png": 566,
	"./recipes/76": 567,
	"./recipes/76.png": 567,
	"./recipes/77": 568,
	"./recipes/77.png": 568,
	"./recipes/78": 569,
	"./recipes/78.png": 569,
	"./recipes/79": 570,
	"./recipes/79.png": 570,
	"./recipes/8": 571,
	"./recipes/8.png": 571,
	"./recipes/80": 572,
	"./recipes/80.png": 572,
	"./recipes/81": 573,
	"./recipes/81.png": 573,
	"./recipes/82": 574,
	"./recipes/82.png": 574,
	"./recipes/83": 575,
	"./recipes/83.png": 575,
	"./recipes/84": 576,
	"./recipes/84.png": 576,
	"./recipes/85": 577,
	"./recipes/85.png": 577,
	"./recipes/86": 578,
	"./recipes/86.png": 578,
	"./recipes/87": 579,
	"./recipes/87.png": 579,
	"./recipes/88": 580,
	"./recipes/88.png": 580,
	"./recipes/89": 581,
	"./recipes/89.png": 581,
	"./recipes/9": 582,
	"./recipes/9.png": 582,
	"./recipes/90": 583,
	"./recipes/90.png": 583,
	"./recipes/91": 584,
	"./recipes/91.png": 584,
	"./recipes/92": 585,
	"./recipes/92.png": 585,
	"./recipes/93": 586,
	"./recipes/93.png": 586,
	"./recipes/94": 587,
	"./recipes/94.png": 587,
	"./recipes/95": 588,
	"./recipes/95.png": 588,
	"./recipes/96": 589,
	"./recipes/96.png": 589,
	"./recipes/97": 590,
	"./recipes/97.png": 590,
	"./recipes/98": 591,
	"./recipes/98.png": 591,
	"./recipes/99": 592,
	"./recipes/99.png": 592,
	"./recipes/critical-photons": 593,
	"./recipes/critical-photons.png": 593,
	"./recipes/default": 594,
	"./recipes/default.png": 594,
	"./tags/early-game": 595,
	"./tags/early-game.png": 595,
	"./tags/late-game": 596,
	"./tags/late-game.png": 596,
	"./tags/mass-1": 597,
	"./tags/mass-1.png": 597,
	"./tags/mass-2": 598,
	"./tags/mass-2.png": 598,
	"./tags/mass-3": 599,
	"./tags/mass-3.png": 599,
	"./tags/mass-4": 600,
	"./tags/mass-4.png": 600,
	"./tags/mass-5": 601,
	"./tags/mass-5.png": 601,
	"./tags/mid-game": 602,
	"./tags/mid-game.png": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;